import { render } from "./single-static.vue?vue&type=template&id=6e8ee49d&lang=pug"
import script from "./single-static.vue?vue&type=script&setup=true&lang=js"
export * from "./single-static.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__